import React from "react";
import { Shield } from "lucide-react";

const CLASSIFY = {
  high: {
    natures: ["Fraud or Misrepresentation", "Child Support or Family"],
    label: "High — Likely Survives Bankruptcy",
    color: "#2ECC71",
    copy: (nature) =>
      `${nature} judgments are largely non-dischargeable under 11 U.S.C. § 523 — creditors can typically pursue collection after Chapter 7 discharge.`,
  },
  moderate: {
    natures: ["Contract Dispute", "Property Damage", "Personal Injury"],
    label: "Moderate — Lien May Survive if Properly Recorded",
    color: "#F39C12",
    copy: (nature) =>
      `${nature} judgments may survive bankruptcy as recorded liens on real property. Ensure the abstract of judgment is filed in every county where the debtor owns property.`,
  },
  standard: {
    natures: ["Consumer Debt"],
    label: "Standard — Subject to Discharge",
    color: "#C0C0C0",
    copy: (nature) =>
      `${nature} judgments are typically dischargeable in Chapter 7 unless the debt qualifies for a § 523 exception (e.g. luxury goods > $675 within 90 days of filing).`,
  },
};

const classify = (nature) => {
  if (!nature || nature === "Other") return null;
  for (const key of Object.keys(CLASSIFY)) {
    if (CLASSIFY[key].natures.includes(nature)) return { key, ...CLASSIFY[key] };
  }
  return null;
};

const BankruptcyCard = ({ debtor }) => {
  const nature = debtor?.judgment?.nature_of_debt || null;
  const cfg = classify(nature);
  const isOther = nature === "Other" || !cfg;

  return (
    <div className="bg-bg-secondary border border-border-default rounded-[12px] p-6" data-testid="bankruptcy-card">
      <h3 className="text-white font-semibold text-[16px]">Bankruptcy Survivability</h3>
      <div className="mt-4">
        {isOther ? (
          <div className="flex items-start gap-3">
            <Shield size={18} className="text-text-secondary mt-0.5" />
            <div>
              <div className="text-text-secondary font-semibold text-[14px]">Manual Review Required</div>
              <p className="text-[13px] text-text-secondary mt-1">
                <a href="#" className="text-accent-pink hover:underline">Consult a licensed attorney</a> to
                assess survivability for this debt type.
              </p>
            </div>
          </div>
        ) : (
          <div className="flex items-start gap-3" data-testid={`bankruptcy-classification-${cfg.key}`}>
            <Shield size={20} style={{ color: cfg.color }} className="mt-0.5 shrink-0" />
            <div>
              <div className="text-[14px] font-semibold" style={{ color: cfg.color }}>{cfg.label}</div>
              <p className="text-[13px] text-text-secondary mt-1 leading-5">{cfg.copy(nature)}</p>
            </div>
          </div>
        )}
      </div>
      <div className="mt-4 pt-4 border-t border-border-default text-[11px] text-text-muted">
        Nature of debt: <span className="text-text-secondary">{nature || "—"}</span>
      </div>
    </div>
  );
};

export default BankruptcyCard;
